module.exports = __webpack_public_path__ + "img/btn_tablast_active.37a7543d.png";